<template>
  <section id="validator-action-section">
    <div class="button-wrapper">
      <a href="https://svt.one/" target="_blank">
        SVT
        <span>smart validator toolkit</span>
      </a>
    </div>
  </section>
</template>

<style scoped lang="scss">
.button-wrapper {
  display: grid;
  place-items: center;

  a {
    width: 312px;
    height: 118px;
    border-radius: 110px;
    background: $green;
    font-family: $button-font;
    font-size: 56px;
    font-style: normal;
    font-weight: 600;
    color: $base-white;
    text-decoration: none;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    span {
      color: rgba(255, 255, 255, 0.7);
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      letter-spacing: 1.04px;
    }

    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
